<template>
  <section id="admin-filter">
    <h4>Tariff Sets filter</h4>
    <div class="form-group">
      <label for="name" class="form-label">Name</label>
      <input type="text" class="form-control" id="name" v-model="entity.name"/>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  import HelperMixin from '../../mixins/Helpers'
  export default {
    name: 'BrandGroupFilter',
    mixins: [ FilterMixin, HelperMixin ],
    data () {
      return {
        entity: {
          name: ''
        }
      }
    },
    components: {
    },
    methods: {
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// BrandGroupFilter.vue?3ebf23cf